module.exports = __webpack_public_path__ + "assets/img/news-1.717ed7dc.jpg";